export const stackDict = {
	campaign: '/sprites/campaign-02573179917f29e953c9367dca0edf6a.svg',
	common: '/sprites/common-0834dd7a361c532865a5049eedc9c8e4.svg',
	execution: '/sprites/execution-f91744803d57405e2538963773f12843.svg',
	linkedin: '/sprites/linkedin-e04ea31c0ef49993478ec7fcba8ca157.svg',
}

type CampaignIcon =
	| 'archive'
	| 'clone'
	| 'complete'
	| 'run'
	| 'stop'
	| 'unarchive'
type CommonIcon =
	| 'arrow'
	| 'arrow-double'
	| 'ascend'
	| 'back-arrow'
	| 'clock'
	| 'close'
	| 'comp-network'
	| 'csv'
	| 'dollar'
	| 'export'
	| 'file'
	| 'filters'
	| 'gear'
	| 'info'
	| 'linked'
	| 'message'
	| 'pencil'
	| 'plus'
	| 'scheduled'
	| 'send'
	| 'sign-in'
	| 'start'
	| 'stop'
	| 'trash'
	| 'user'
	| 'refresh'
type ExecutionIcon = 'clock' | 'connect' | 'folder' | 'like' | 'stop' | 'view'
type LinkedinIcon =
	| 'attach'
	| 'check'
	| 'dots'
	| 'download'
	| 'emoji'
	| 'pic'
	| 'reply'
	| 'stop'
export type { CampaignIcon, CommonIcon, ExecutionIcon, LinkedinIcon }
